import { ExtendedApiObject } from '@bpd-library/utilities';
import { translateItem } from '@utilities/hooks';

import { FormattedStatus } from './types';

type OmitValue<T, K extends T> = T extends K ? never : T;

export type TranslatedStatus = OmitValue<
    ExtendedApiObject['status'],
    'AmountAvailable' | 'NotActive' | undefined
>;

const TRANSLATED_EVENT = 'status-translations::loaded';

class StatusTranslator {
    _formattedStatuses: Record<TranslatedStatus, FormattedStatus>;
    _translatedStatuses: Record<TranslatedStatus, string>;
    isTranslated: boolean = false;

    private async init() {
        this._translatedStatuses = {
            InPreparation: await translateItem('StatusLabel-InVoorbereiding'),
            SaleSoon: await translateItem('SoonOnSale'),
            SaleStarted: await translateItem('SalesStarted'),
            OnSale: await translateItem('StatusLabel-InVerkoop'),
            Available: await translateItem('Enum-ConstructionNumberStatus-Vrij'),
            ForRent: await translateItem('Enum-ProjectStatus-InVerhuur'),
            InOption: await translateItem('houses-overview-status-option'),
            AssigningOn: await translateItem('StatusLabel-AssigningOn'),
            Reserved: await translateItem('Reserved'),
            Sold: await translateItem('Enum-ConstructionNumberStatus-Verkocht'),
            Rented: await translateItem('Enum-ProjectStatus-Verhuurd'),
            UnderConstruction: await translateItem('UnderConstructionInhabited'),
        };

        this._formattedStatuses = {
            InPreparation: {
                label: this._translatedStatuses.InPreparation,
                color: 'grey',
            },
            SaleSoon: {
                label: this._translatedStatuses.SaleSoon,
                color: 'grey',
            },
            SaleStarted: {
                label: this._translatedStatuses.SaleStarted,
                color: 'green',
            },
            OnSale: {
                label: this._translatedStatuses.OnSale,
                color: 'green',
            },
            Available: {
                label: this._translatedStatuses.Available,
                color: 'green',
            },
            ForRent: {
                label: this._translatedStatuses.ForRent,
                color: 'green',
            },
            InOption: {
                label: this._translatedStatuses.InOption,
                color: 'orange',
            },
            AssigningOn: {
                label: this._translatedStatuses.AssigningOn,
                color: 'orange',
            },
            Reserved: {
                label: this._translatedStatuses.Reserved,
                color: 'orange',
            },
            Sold: {
                label: this._translatedStatuses.Sold,
                color: 'red',
            },
            Rented: {
                label: this._translatedStatuses.Rented,
                color: 'red',
            },
            UnderConstruction: {
                label: this._translatedStatuses.UnderConstruction,
                color: 'purple',
            },
        };

        this.isTranslated = true;

        document.dispatchEvent(
            new CustomEvent(TRANSLATED_EVENT, { detail: { isTranslated: true } }),
        );
    }

    constructor() {
        this.init();
    }

    get LABEL() {
        return this._translatedStatuses;
    }

    get FORMATTED() {
        return this._formattedStatuses;
    }
}

const StatusTranslations = new StatusTranslator();

export { StatusTranslations, TRANSLATED_EVENT };
